export default "__VITE_ASSET__3oHYkw51__"